module.exports = __webpack_public_path__ + "static/media/play-hover.21e1e31a.svg";